
import HeaderCart from '@/components/HeaderCart.vue'
import FixedHeader from 'vue-fixed-header'

export default {
  name: 'TheMenu',
  components: { FixedHeader, HeaderCart },
  data() {
    return {
      widgetLoaded: false,
      reviewStats: {
        rating: null,
        count: null,
      },
      quickLinks: [],
      socialNetworks: [
        {
          key: 'facebook',
          href: 'https://www.facebook.com/agmvision/',
          icon: 'facebook-f',
        },
        {
          key: 'instagram',
          href: 'https://www.instagram.com/agm_vision/',
          icon: 'instagram',
        },
        {
          key: 'tiktok',
          href: 'https://www.tiktok.com/@agmvision',
          icon: 'tiktok',
        },
        {
          key: 'youtube',
          href: 'https://www.youtube.com/@agmvision',
          icon: 'youtube',
        },
      ],
    }
  },
  computed: {
    vehicleCount() {
      return this.$store.getters.vehicle_search_history?.length || 0
    },
    formattedRating() {
      const rating = parseFloat(this.reviewStats.rating)
      return isNaN(rating) ? '4.9' : rating.toFixed(1)
    },
    formattedReviewsCount() {
      const count = Number(this.reviewStats.count) || 0
      return this.$tc('components.menu.reviews', count, { count })
    },
    defaultQuickLinks() {
      return [
        {
          id: 'default-1',
          label: this.$t('components.menu.goodDeals'),
          link: this.localePath({ name: 'bonnes-affaires' }),
        },
        {
          id: 'default-2',
          label: this.$t('components.menu.promoCodes'),
          link: this.localePath({ name: 'code-promo' }),
        },
        {
          id: 'default-3',
          label: this.$t('components.menu.tipsAndTutorials'),
          link: this.localePath({ name: 'blog-led-accessoires-vehicules' }),
        },
      ]
    },
  },
  mounted() {
    this.loadReviewStats()
    this.loadQuickLinks()
    this.loadSkeepersWidget()
  },
  methods: {
    async loadQuickLinks() {
      try {
        const { data } = await this.$quickLinkService.fetch({
          sort: 'position',
        })
        const apiLinks = data?.length
          ? data.map(ql => ({
              ...ql,
              link: this.localePath(ql.localized_link || ql.link),
            }))
          : []
        this.quickLinks =
          apiLinks.length <= 1
            ? [...apiLinks, ...this.defaultQuickLinks]
            : apiLinks
      } catch {
        this.quickLinks = this.defaultQuickLinks
      }
    },
    async loadReviewStats() {
      try {
        const response =
          await this.$verifiedReviewsService.fetchSummarySkeepers()
        this.reviewStats = {
          rating: response.average || 4.9,
          count: response.count_total_since_creation || null,
        }
      } catch {
        this.reviewStats = { rating: 4.9, count: null }
      }
    },
    loadSkeepersWidget() {
      if (process.client) {
        try {
          const widgetId = 'db60a874-e6ec-44e5-b7d7-79c0bd78a76a'
          const scriptId = 'skeepers-menu-widget'
          const widgetContainer = document.getElementById(widgetId)

          if (widgetContainer) {
            if (widgetContainer.children.length > 0) {
              this.widgetLoaded = true
              return
            }

            const observer = new MutationObserver(() => {
              if (widgetContainer.children.length > 0) {
                this.widgetLoaded = true
                observer.disconnect()
              }
            })
            observer.observe(widgetContainer, { childList: true })
          }

          const existingScript = document.getElementById(scriptId)
          if (existingScript) {
            existingScript.remove()
          }

          const script = document.createElement('script')
          script.id = scriptId
          script.src = `https://widgets.rr.skeepers.io/generated/5e0737dc-e1e6-bba4-f965-f42331423733/${widgetId}.js`
          script.defer = true
          script.onerror = () => script.remove()
          document.body.appendChild(script)
        } catch {}
      }
    },
  },
}
